import DetailPPA from './DetailPPA'

export default DetailPPA